module.exports = __webpack_public_path__ + "img/tel1.bc44f89c.jpg";